export const VENDOR_IMPORT_TEMPLATE_HEADERS = [
  'Vendor Name',
  'Vendor Code',
  'Email',
  'Password',
  'Contact Number',
  'Alternate Contact Number',
  'Address Line 1',
  'City',
  'State',
  'Country',
  'Categories',
  'Service Regions',
  'Supply Capacity',
  'Onboarding Duration',
  'Onboarding Start Date',
  'Onboarding End Date',
  'Payment Terms',
  'Remittance Instructions',
  'GST / Tax No',
  'Contact Person',
] as const

export const VENDOR_OWNERSHIP_HEADERS = [
  'Company Group',
  'Company',
  'Company Group Admin',
  'Company Group Admin ID',
  'Company Group ID',
  'Company Admin',
  'Company Admin ID',
  'Sub-Company',
  'Sub Company',
] as const

export function templateExcludesOwnershipColumns(headerLine: string): boolean {
  const normalized = headerLine.toLowerCase()
  return !VENDOR_OWNERSHIP_HEADERS.some((header) => normalized.includes(header.toLowerCase()))
}

export function buildVendorImportErrorReportCsv(
  errors: Array<{
    rowNumber: number
    vendorName?: string
    vendorCode?: string
    field?: string
    value?: string
    errorCode?: string
    message?: string
    reason?: string
    errors?: Array<{ field?: string; value?: string; errorCode?: string; message?: string }>
  }>,
  previewRows?: Array<{ rowNumber: number; vendorName?: string; vendorCode?: string }>
): string {
  const previewLookup = new Map(
    (previewRows ?? []).map((row) => [row.rowNumber, row])
  )
  const lines = ['Row Number,Vendor Name,Vendor Code,Field,Invalid Value,Error Code,Reason']
  for (const error of errors) {
    const preview = previewLookup.get(error.rowNumber)
    const vendorName = preview?.vendorName ?? error.vendorName ?? ''
    const vendorCode = preview?.vendorCode ?? error.vendorCode ?? ''
    const fieldErrors = error.errors?.length
      ? error.errors
      : [{
          field: error.field,
          value: error.value,
          errorCode: error.errorCode,
          message: error.message ?? error.reason,
        }]
    for (const fieldError of fieldErrors) {
      lines.push(
        [
          error.rowNumber,
          csvEscape(vendorName),
          csvEscape(vendorCode),
          csvEscape(fieldError.field ?? ''),
          csvEscape(fieldError.value ?? ''),
          csvEscape(fieldError.errorCode ?? ''),
          csvEscape(fieldError.message ?? error.reason ?? ''),
        ].join(',')
      )
    }
  }
  return lines.join('\n')
}

function csvEscape(value: string): string {
  if (/[",\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`
  }
  return value
}
